import { Group, Text, Badge } from '@mantine/core';
import { IconFlame, IconArrowUp } from '@tabler/icons-react';

export function TrendingHeader() {
  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);

  const formattedDate = yesterday.toLocaleDateString('it-IT', {
    day: 'numeric',
    month: 'short',
    year: 'numeric'
  });

  return (
    <div style={{ marginBottom: '24px' }}>
      <Group align="center" mb={8}>
        <Group gap={8}>
          <IconFlame size={24} style={{ color: 'red' }} />
          <Text size="xl" fw={600}>Trending Videos</Text>
        </Group>
        <Badge 
          variant="light" 
          color="red" 
          leftSection={<IconArrowUp size={12} />}
        >
          Today's Hits
        </Badge>
      </Group>
      <Text c="dimmed" size="sm">
        Scopri i video più visti il {formattedDate} • Aggiornati ogni giorno
      </Text>
    </div>

  );
} 